<template>
  <div class="doctor_index">
    <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>名医工作室</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="doctor_center">
      <div class="doctor_content_alt">名医工作室<span></span></div>
      <div class="doctor_content">
        <div class="doctor_li" v-for="(item,index) in doctorArr" :key="index" @click="doctorgo(item,index)">
          <img :src="item.avatar" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import data from '../../../static/doctors.json'
export default {
    data(){
        return{
          doctorArr:[]
        }
    },
    created(){
      this.doctorArr = data
      // console.log(this.doctorArr)
      // this.loaddoctor()
    },
    methods:{
      loaddoctor(){
        
      },
        doctorgo(item,index){
          // console.log(item)
          // console.log(index)
          this.$router.push({
            path:'/doctorDetail',
            query:{
              name:item.name
            }
			    })
        }
    }
};
</script>
<style lang="scss" scoped>
.doctor_index {
  width: 1200px;
  //   height: 800px;
  margin: 0 auto;
  //   border: 1px solid red;
  .doctor_head {
    color: #666;
    font-size: 14px;
    text-indent: 60px;
    padding: 20px 0px;
    font-family: PingFang SC;
    span {
      color: #e6522b;
    }
  }
  .doctor_center{
      width: 100%;
    // border: 1px solid red;
    background: #fff;
    padding-top: 40px;
    .doctor_content_alt {
      width: fit-content;
      height: 31px;
      font-size: 24px;
      font-family: Alibaba PuHuiTi;
      font-weight: bold;
      color: rgba(0, 0, 0, 1);
      margin-left: 60px;
      position: relative;
      z-index: 2;
      span{
        width: 100%;
        height: 6px;
        display: inline-block;
        position: absolute;
        bottom: 1px;
        left: 0;
        z-index: -1;
        background: #E6522B;
      }
    }
  }
  .doctor_content {
    width: 100%;
    height: 720px;
    display: flex;
    flex-wrap: wrap;
    padding-top: 30px;
    box-sizing: border-box;
    margin-bottom: 60px;
    .doctor_li {
      width: 314px;
      height: 280px;
      margin-left: 70px;
      cursor: pointer;
      img {
        width: 100%;
        height: 100%;
        display: block;
				object-fit: cover;
      }
      &:nth-child(1),
      &:nth-child(4) {
        margin-left: 60px;
      }
      &:hover {
        box-shadow: 0px 1px 8px 0px rgba(130, 49, 19, 0.29);
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/page/doctor.vue